<section class="custom-header" style="margin-bottom: 20px;">
  <h2 class="dialog-title-text">Parametri</h2>
</section>

<div *ngIf="isLoading" fxLayout="row" fxLayoutAlign="center center" style="padding: 20px;">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<form [style.display]="isLoading ? 'none' : 'block'">
  <section class="reports-details" mat-dialog-content>
    <ng-container #container></ng-container>
  </section>

  <div class="actions-section" fxLayout="row" fxLayoutAlign="end center">
    <button
      mat-raised-button
      color="primary"
      type="button"
      [disabled]="!isFormValidForGeneration() || isGeneratingReport"
      (click)="onGenerateReport()"
      class="generate-btn"
    >
      <mat-spinner *ngIf="isGeneratingReport" diameter="18" class="button-spinner"></mat-spinner>
      <mat-icon *ngIf="!isGeneratingReport">play_arrow</mat-icon>
      <span>{{ isGeneratingReport ? 'Generisanje...' : 'Prikaži izveštaj' }}</span>
    </button>
  </div>

  <div *ngIf="hasUnappliedChanges && isFormValidForGeneration()" class="unapplied-changes-badge">
    <mat-icon inline>info</mat-icon>
    <span>Parametri su izmenjeni. Kliknite na "Prikaži izveštaj" za osvežavanje.</span>
  </div>

   <div *ngIf="!isFormValidForGeneration()" class="validation-error-badge">
    <span>Početni datum ne može biti nakon krajnjeg datuma. Molimo vas da izaberete ispravan vremenski opseg.</span>
  </div>
</form>